import { ADMIN, FULLADMIN } from '../../../constants/roles';
import { Dropdown, Option } from '@align-cpf/uikit';
import { useGlobalContext } from '../../context';
import React from 'react';
import useStyles from './Dropdown.styles';

interface CustomDropdownProps {
  selectedValue: string;
  options: Array<{ value: string; label: string }>;
  handleValueChange: (value: string) => void;
  currentRegion: string;
}

export const CustomDropdown: React.FC<CustomDropdownProps> = ({
  selectedValue,
  options,
  handleValueChange,
  currentRegion,
}) => {
  const classes = useStyles();
  const { userdata } = useGlobalContext();
  const handleChange = (value: string) => {
    handleValueChange(value);
  };

  return (
    <div className={classes.selectContainer}>
      {(userdata.roles.includes(ADMIN) ||
        userdata.roles.includes(FULLADMIN)) && (
        <div className={classes.dropdownContainer}>
          <Dropdown value={selectedValue} onChange={handleChange}>
            {options.map(option => (
              <Option
                key={option.value}
                value={option.value}
                label={option.label}
                disabled={option.value === currentRegion}
              />
            ))}
          </Dropdown>
        </div>
      )}
    </div>
  );
};
